/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class TimeBlock extends Component {
  _goItems = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };
  _renderItem = () => {
    const { timeItems, part } = this.props.childProps;
    const { imgUrl } = this.props;
    const list = timeItems.map((item, index) => {
      let mm;
      let hh;

      if (item.mm === 0) {
        mm = '00';
      } else {
        mm = item.mm;
      }
      if (item.hh === 0) {
        hh = '00';
      } else {
        hh = item.hh;
      }

      return (
        <div key={index} className={part === 'tv' ? 'time_box1' : 'time_box'}>
          {' '}
          {/*item.sec > 1800 ? "time_box time_height2" : "time_box"*/}
          <dl>
            <dt style={{ top: 5 }}>{mm}</dt>
            <dd style={{ whiteSpace: 'pre-wrap' }}>
              {/*<span class="time_new" ><img src="/img/detail_img/airing_icon.png"/></span>*/}
              {part === 'tv' ? null : (
                <img
                  src={item.img}
                  style={{ width: 129, cursor: 'pointer' }}
                  onClick={() => this._goItems(item.contentSerial)}
                />
              )}
              <p
                style={{ cursor: 'pointer' }}
                onClick={() => this._goItems(item.contentSerial)}
              >
                {item.title}
              </p>
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => this._goItems(item.contentSerial)}
              >
                {item.subTitle}
              </div>

              {item.restrictionCode === 19 ? (
                <em>{item.restrictionCode}</em>
              ) : null}
              {item.gubun === '' ? null : <span>{item.gubun}</span>}
              {part === 'tv' ? null : item.sameAir === 'Y' ? (
                <div
                  className="kj_icon"
                  style={
                    part === 'tv'
                      ? { position: 'relative', top: -30, left: 85 }
                      : null
                  }
                >
                  <img
                    src={imgUrl + '/img/detail_img/airing_icon.png'}
                    alt=""
                  />
                </div>
              ) : null}
            </dd>
          </dl>
        </div>

        /*
                <div style={{ paddingLeft: 10}}>
                    {item.mm}분 {item.subTitle}
                </div>
                */
      );
    });

    return list;
  };

  render() {
    const { timeItems } = this.props.childProps;
    //console.log(timeItems)
    return (
      <Fragment>
        {timeItems.length > 0 ? (
          this._renderItem()
        ) : (
          <div style={{ color: '#ffffff', textAlign: 'center' }}>
            준비중입니다.
          </div>
        )}

        {/*
                <div style={{ paddingLeft: 10}}>
                    00분 던전에서.. 11화
                </div>
                <div style={{ paddingLeft: 10}}>
                    30분 던전에서.. 11화
                </div>
                */}
        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(TimeBlock));
